import { IRecord } from "../../interfaces/interfaces";

export const adapterListResponse = (response: any) => {
  let newResponse: IRecord[] = response.data?.map((r: any) => {
    return {
      _id: r._id,
      name: r.name,
      email: r.email,
      phone: r.phone,
      date: r.date,
    };
  });

  return newResponse.reverse();
};
